import { PAYOUT_BANK_DATA, PAYOUT_BANK_ERROR, PAYOUT_BANK_HIDE_ERROR, } from "../interface/iPayoutBankDetails";
const initialState = {
    data: {},
    errorData: { error: null, isOpen: false },
};
const PayoutBankReducer = (state = initialState, action) => {
    switch (action.type) {
        case PAYOUT_BANK_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case PAYOUT_BANK_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case PAYOUT_BANK_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        default:
            return Object.assign({}, state);
    }
};
export default PayoutBankReducer;
